import React from 'react';
import { ChipContainer, ChipLabel, IconWrapper } from './styles';
var Chip = function (_a) {
    var label = _a.label, icon = _a.icon, _b = _a.selected, selected = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.fitContent, fitContent = _d === void 0 ? false : _d;
    return (React.createElement(ChipContainer, { selected: selected, size: size, fitContent: fitContent, onClick: onClick },
        icon && React.createElement(IconWrapper, null, icon),
        React.createElement(ChipLabel, null, label)));
};
export default Chip;
